import { getSlideIndices } from "library";
import { executeCode } from "./execute";
import { showTab } from "./tabs";
import {
  applyTypewriter,
  parseTypewriter,
  startTypewriters,
  TypeWriterHandler,
  typeWriterHandler,
} from "./typewriter";

let executedFragment = null;

export function initialiseAnimations() {
  Reveal.addEventListener("fragmentshown", async function (event) {
    await handleAnimations();
  });

  Reveal.addEventListener("fragmenthidden", async function (event) {
    await handleAnimations();
  });
}

export async function handleAnimations() {
  // HANDLE ANIMATIONS
  typeWriterHandler.stopTheCurrentTypewriter();

  const { fragment: fragmentIndex } = getSlideIndices();
  const slide = Reveal.getCurrentSlide();
  const tricode = slide.querySelector(".tricode");
  const fragments = Array.from(slide.querySelectorAll(".fragment")).sort(
    (a, b) => {
      return (
        parseInt(a.getAttribute("data-fragment-index")) -
        parseInt(b.getAttribute("data-fragment-index"))
      );
    }
  ) as HTMLDivElement[];

  const currentFragments = fragments.filter(
    (f) => parseInt(f.getAttribute("data-fragment-index")) <= fragmentIndex
  );

  // INITIALISE
  // TYPEWRITERS

  const typewriters = fragments.filter((f) =>
    f.classList.contains("typewriter")
  );
  if (typewriters.length) {
    // clear all typewriters
    for (const fragment of typewriters) {
      const { indices, replacements } = parseTypewriter(fragment);
      let i = 0;
      for (const index of indices) {
        await fragment.__typewriterClear(index, replacements[i++]);
      }
    }
  }

  // INITIALISE TABS
  // TABS
  if (tricode) {
    // first slide always shows
    showTab("tricode", tricode.getAttribute("data-tricode-tab") || "tricode");
  }

  // we only execute the last possible one of executions and tab changes
  const executionFragment = currentFragments
    .filter((f) => f.classList.contains("execute"))
    .slice(-1)[0];

  const tabFragment = currentFragments
    .filter(
      (f) =>
        f.classList.contains("tricode-css") ||
        f.classList.contains("tricode-html") ||
        f.classList.contains("tricode-code")
    )
    .slice(-1)[0];

  const process = {
    run: true,
    speed: 25,
    id: TypeWriterHandler.getUid(),
  };

  const pendingTypewriters = [];

  for (const fragment of currentFragments) {
    const isCurrent =
      parseInt(fragment.getAttribute("data-fragment-index")) == fragmentIndex;

    // TYPEWRITERS
    if (fragment.classList.contains("typewriter")) {
      // previous typewriters flush
      // current typewriter types
      if (isCurrent) {
        pendingTypewriters.push(fragment);
        // apply the dataset
        applyTypewriter(fragment);
      } else {
        const { target, indices, replacements, highlightedTexts } =
          parseTypewriter(fragment);
        let i = 0;
        for (const index of indices) {
          await fragment.__typewriterFlush(
            index,
            replacements[i],
            highlightedTexts[i]
          );
          i++;
        }
      }
    }

    if (process.run == false) {
      return;
    }

    // CHECK

    // const checkIndex = Reveal.getIndices().f;
    // if (checkIndex != fragmentIndex) {
    //   return;
    // }

    // EXECUTIONS

    const frame: HTMLIFrameElement = slide.querySelector(".triframe");
    if (executionFragment) {
      if (fragment == executionFragment) {
        if (executedFragment != executionFragment) {
          console.log(
            "Executing code: " +
              executionFragment.getAttribute("data-fragment-properties")
          );
          executedFragment = executionFragment;
          executeCode(executionFragment);
        }
      }
    } else if (frame) {
      executedFragment = null;
      frame.srcdoc = "";
      frame.classList.remove("iframeExecuted");
    }

    // TAB CHANGES

    if (tabFragment && fragment == tabFragment) {
      if (tabFragment.classList.contains("tricode-css")) {
        showTab("tricode", "tricss");
      }
      if (tabFragment.classList.contains("tricode-html")) {
        showTab("tricode", "trihtml");
      }
      if (tabFragment.classList.contains("tricode-code")) {
        showTab("tricode", "tricode");
      }
    }
  }

  if (pendingTypewriters.length) {
    startTypewriters(pendingTypewriters, process);
  }
}

export function setIframeSizes() {
  const style = window.getComputedStyle(document.querySelector(".slides"));
  const scale = parseFloat(
    style.transform.split("(")[1].split(")")[0].split(",")[0]
  );
  const ratio = 1 / scale;

  const iframes: NodeListOf<HTMLIFrameElement> =
    document.querySelectorAll("iframe");
  for (const iframe of iframes) {
    const rect = iframe.getBoundingClientRect();
    iframe.width = Math.round(rect.width * ratio * 2).toString();
    iframe.height = Math.round(rect.height * ratio * 2).toString();
  }
}
